module.exports = __webpack_public_path__ + "img/case.b0c53a90.png";